import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";

export default function HeroCarousel() {
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => { api.get("/marketing/banners").then(r => setBanners(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (banners.length <= 1) return;
    const t = setInterval(() => setIdx(i => (i + 1) % banners.length), 6000);
    return () => clearInterval(t);
  }, [banners.length]);

  if (banners.length === 0) return null;
  const b = banners[idx];

  return (
    <section className="lumina-container py-12" data-testid="hero-carousel">
      <div className="relative rounded-[2.5rem] overflow-hidden">
        <div className="relative h-[420px] md:h-[460px]">
          {banners.map((banner, i) => (
            <div
              key={banner.id}
              className={`absolute inset-0 transition-opacity duration-700 ${i === idx ? "opacity-100" : "opacity-0 pointer-events-none"}`}
              data-testid={`banner-${i}`}
            >
              <img src={banner.image?.startsWith("/") ? (process.env.REACT_APP_BACKEND_URL || "") + banner.image : banner.image} alt={banner.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#1A1728]/85 via-[#1A1728]/55 to-transparent"></div>
              <div className="absolute inset-0 flex items-center">
                <div className="px-8 md:px-16 max-w-2xl">
                  <div className="text-xs uppercase tracking-[0.3em] text-white/70 mb-4">HearInsight Promo</div>
                  <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-white mb-4 leading-tight">{banner.title}</h2>
                  <p className="text-white/90 mb-7 text-lg leading-relaxed">{banner.subtitle}</p>
                  {banner.cta_text && banner.cta_link && (
                    <Link to={banner.cta_link} className="inline-flex items-center gap-2 bg-white text-[#6B4BA3] hover:bg-[#E8F0FA] px-7 py-3.5 rounded-full font-medium transition-colors" data-testid={`banner-cta-${i}`}>
                      {banner.cta_text} <ArrowRight className="w-4 h-4" />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {banners.length > 1 && (
          <>
            <button onClick={() => setIdx((idx - 1 + banners.length) % banners.length)}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 backdrop-blur flex items-center justify-center text-white"
              data-testid="carousel-prev">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={() => setIdx((idx + 1) % banners.length)}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 backdrop-blur flex items-center justify-center text-white"
              data-testid="carousel-next">
              <ChevronRight className="w-5 h-5" />
            </button>
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
              {banners.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)}
                  className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-white" : "w-2 bg-white/50 hover:bg-white/70"}`}
                  data-testid={`carousel-dot-${i}`} />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
